import {
    AutocompleteArrayInput,
    BooleanInput,
    ReferenceArrayInput,
  } from "react-admin";
  import React, { useEffect, useState } from "react";
  import { useField } from "react-final-form";
  
  const BusAssistantsInput = () => {
    const notificationTargetTypeField = useField("notificationTargetType");
    const routeInput = useField("routeIds");
    const schoolInput = useField("schoolId");
    const busScheduleInput = useField("busScheduleIds");
  
    const isSendToAllField = useField("isSendToAllBusAssistants");
    const busAssistantIdsField = useField("busAssistantIds");
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const [isFocused, setIsFocused] = useState<boolean>(false);
  
    useEffect(() => {
      if (isSendToAllField.input.value) {
        setIsDisabled(true);
        busAssistantIdsField.input.onChange([]);
      } else {
        setIsDisabled(false);
        busAssistantIdsField.input.onChange([]);
      }
    }, [isSendToAllField.input.value]);
  
    const filter = (targetType: string) => {
      let filter;
      switch (targetType) {
        case "school":
          filter = { 
            ActiveAssignmentSchoolId: Number(schoolInput.input.value), 
            Type: "assistant"
          };
          break;
        case "bus_schedule":
          filter = {
            ActiveAssignmentBusScheduleIds: busScheduleInput.input.value,
            Type: "assistant"
          };
          break;
        case "route":
          filter = { 
            ActiveAssignmentRouteIds: routeInput.input.value,
            Type: "assistant"
          };
          break;
      }
  
      return filter;
    };

    const handleFocus = () => {
      setIsFocused(true);
    };
  
    const handleBlur = () => {
      setIsFocused(false);
    };
  
    return (
      <>
        <ReferenceArrayInput
          label="Bus Assistant"
          source="busAssistantIds"
          reference="listDriversForNotification"
          filter={isFocused ? filter(notificationTargetTypeField.input.value) : {}}
          filterToQuery={(searchText: string) => {
            if (searchText !== "") return { search: searchText };
          }}
          sort={{ field: "name", order: "ASC" }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={isDisabled}
        >
          <AutocompleteArrayInput optionText="fullName" debounce={1000} />
        </ReferenceArrayInput>
        <BooleanInput label="Send To All Bus Assistants" source="isSendToAllBusAssistants" />
      </>
    );
  };
  
  export default BusAssistantsInput;
  